// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/imagesbackground.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/chunkyglitter_1091945-772.avif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Roboto:wght@400;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hr-heading {
  font-family: 'Open Sans', sans-serif; 
  font-size: 24px;
  font-weight: 600;
  color: #FCA510; 
  margin-bottom: 10px;
  text-align: center;
}
body {
  margin: 0;
  padding: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: cover; 
  font-family: 'Open Sans', sans-serif;
}


.form-container {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
  background-size: cover;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  padding: 25px;
  border-radius: 10px;
  border: 1px solid #ddd;
  max-width: 700px;
  margin: 20px auto;
  position: relative;
  z-index: 1;
}



h2 {
  text-align: center;
  margin-bottom: 20px;
}

.form-group {

  padding: 16px;
  border: 1px solid #65b1d7;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 6px;
}

.form-group input[type="text"],
.form-group input[type="email"],
.form-group input[type="date"],
.form-group input[type="number"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #bbb;
  border-radius: 4px;
}

.radio-group {
  display: flex;
  flex-direction: row; 
  gap: 50px; 
  align-items: center;
}

.custom-radio {
  display: flex;
  align-items: center;
  gap: 5px;
}

.submit-btn {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #0056b3;
}
.form-title {
  color: black;
  font-family: "Segoe UI", Helvetica, Arial, sans-serif;
  text-align: center;
  margin-bottom: 20px;
}
.form-row {
  display: flex;
  gap: 40px;
}

.form-row .form-group {
  flex: 1 1;
}

`, "",{"version":3,"sources":["webpack://./src/JobForm.css"],"names":[],"mappings":"AAGA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,2EAA+E;EAC/E,sBAAsB;EACtB,oCAAoC;AACtC;;;AAGA;EACE,2EAAyF;EACzF,sBAAsB;EACtB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;;;AAIA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Roboto:wght@400;500&display=swap');\r\n\r\n\r\n.hr-heading {\r\n  font-family: 'Open Sans', sans-serif; \r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #FCA510; \r\n  margin-bottom: 10px;\r\n  text-align: center;\r\n}\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  background: url('./assets/images/imagesbackground.jpg') no-repeat center center;\r\n  background-size: cover; \r\n  font-family: 'Open Sans', sans-serif;\r\n}\r\n\r\n\r\n.form-container {\r\n  background: url('./assets/images/chunkyglitter_1091945-772.avif') no-repeat center center;\r\n  background-size: cover;\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n  padding: 25px;\r\n  border-radius: 10px;\r\n  border: 1px solid #ddd;\r\n  max-width: 700px;\r\n  margin: 20px auto;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n\r\n\r\nh2 {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-group {\r\n\r\n  padding: 16px;\r\n  border: 1px solid #65b1d7;\r\n  border-radius: 8px;\r\n  margin-bottom: 16px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  font-weight: bold;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.form-group input[type=\"text\"],\r\n.form-group input[type=\"email\"],\r\n.form-group input[type=\"date\"],\r\n.form-group input[type=\"number\"] {\r\n  width: 100%;\r\n  padding: 8px;\r\n  border: 1px solid #bbb;\r\n  border-radius: 4px;\r\n}\r\n\r\n.radio-group {\r\n  display: flex;\r\n  flex-direction: row; \r\n  gap: 50px; \r\n  align-items: center;\r\n}\r\n\r\n.custom-radio {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.submit-btn {\r\n  background-color: #007bff;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.submit-btn:hover {\r\n  background-color: #0056b3;\r\n}\r\n.form-title {\r\n  color: black;\r\n  font-family: \"Segoe UI\", Helvetica, Arial, sans-serif;\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n.form-row {\r\n  display: flex;\r\n  gap: 40px;\r\n}\r\n\r\n.form-row .form-group {\r\n  flex: 1;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
